import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { GroupByMode } from 'shared/types/sorting-mode';

export const useTodayCustomOrderByGrouping = (
  groupBy: GroupByMode | undefined | null,
) => {
  const user = useUser();

  return useMemo(() => {
    if (!groupBy || groupBy === GroupByMode.None) {
      return {
        [GroupByMode.None]:
          user?.settings?.customTaskOrder?.today?.[GroupByMode.None] ?? [],
      };
    }
    return user?.settings?.customTaskOrder?.today?.[groupBy] ?? {};
  }, [groupBy, user?.settings?.customTaskOrder?.today]);
};
